import type { AasApiAdapter } from "../adapter";
import { requestJson } from "../http";
import type { SlackBotStatus } from "../types";

function path(slug: string): string {
	return `/api/agents/${encodeURIComponent(slug)}/slack-bot`;
}

export const slackBotApi: AasApiAdapter["slackBot"] = {
	get(slug) {
		return requestJson<SlackBotStatus>(path(slug));
	},
	connect(slug, input) {
		return requestJson<SlackBotStatus>(path(slug), { method: "PUT", body: input });
	},
	setEnabled(slug, enabled) {
		return requestJson<SlackBotStatus>(path(slug), { method: "PATCH", body: { enabled } });
	},
	async disconnect(slug) {
		await requestJson<void>(path(slug), { method: "DELETE" });
	},
};
